var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4995 14.8615C13.825 14.8615 14.8995 13.787 14.8995 12.4615C14.8995 11.136 13.825 10.0615 12.4995 10.0615C11.174 10.0615 10.0995 11.136 10.0995 12.4615C10.0995 13.787 11.174 14.8615 12.4995 14.8615Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04883 12.4616C2.57793 7.59302 7.12627 4.06152 12.4994 4.06152C17.8726 4.06152 22.4209 7.59298 23.95 12.4615C22.4209 17.33 17.8726 20.8615 12.4994 20.8615C7.12628 20.8615 2.57795 17.3301 1.04883 12.4616ZM17.2995 12.4615C17.2995 15.1125 15.1504 17.2615 12.4995 17.2615C9.84853 17.2615 7.6995 15.1125 7.6995 12.4615C7.6995 9.81056 9.84853 7.66152 12.4995 7.66152C15.1504 7.66152 17.2995 9.81056 17.2995 12.4615Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.e444713e53a830fa27f98671ecc95177.svg";
export { ForwardRef as ReactComponent };